import css from "./InventoryChk2.module.css";
import "./InventoryChk.css"

import { useRef, useState, Fragment } from "react";
import { regUses, useMaps, usePdts, useRcd, useRcds, useTbl, addTblRcds,
    setChkSkidStatus, useChkRawData, useExpandedRcds, delTblRcds } from "../../axios_with_token";
import { useRcdList } from "../../input_types/Tbl/Tbl";
import { useDialog, useRcdEditDialog } from "../../input_types/Dialog/Dialog";
import { useWarehouseSelector } from "../SalesOrderProcess/SalesOrderProcess";
import { generateNewSkidId } from "../../widgets/SkidId/SkidId";

// import { PosChk } from "./InventoryChk";
export function WarehouseChkInfo({warehouseId, chkId}){
    return <div>warehouse info</div>;
}

export function ChkIdSelector({chkId, setChkId}){
    const {regUse, DefaultResponse} = regUses();
    const {Dialog: DlgInvCheckInfoDlg, openDialog:openDlgInvCheckInfoDlg} = useDialog({
        dlgTitle: 'check inventory summary'
    });
    const {data:tblInventoryChecks } = regUse(useTbl('inventoryChecks'));

    const tblName = 'inventoryChecks';
    const {
        // formId: editRcdFormId,
        isDialogOpen,
        setIsDialogOpen,
        openDialog:openEditNewDlg,
        closeDialog,
        handleConfirm,

        setTblName,
        setRcdId:setEditNewRcdId,
        setRcdDefault,
        getRcdDefault,

        invalidate:invalidateRcdInventoryChecks,

        Dialog: EditNewDialog,
        
    } = regUse(useRcdEditDialog({
        tblName,
        rcdId:null,
        onSaved: r=>{
            // invalidateList();
            // forceUpdate();
            const idsChanged = ((r.data.data||[]).find(rcd=>rcd.tblName==tblName)||{}).__idsChanged;
            if(idsChanged){
                const tgtId = idsChanged[0];
                setChkId(tgtId);
            }

        }
    }));

    const filterInventoryCheckItems = {
        __filtersRelation:'all',
        __filterFlds:{
            for: '^(chkInv)$',
            forId: `^(${chkId})$`
        }

    };
    const tblNameInventoryCheckItems = 'inventoryCheckItems';
    // const {data:rcdsInventoryCheckItems} = regUse(useRcds(tblNameInventoryCheckItems,0,9999,filterInventoryCheckItems));
    const {
        Component:ListInventoryCheckItemsList,
        loading:TblListLoading,
        error:TblListError,
        invalidate:invalidateList,
        setActiveRcdId,
        setListType
    } = regUse(useRcdList({
        listType: 'list',

        hideListTypeSelector: true,

        listFlds: 'date,for,forId,dir,warehouseId,warehouseId__xpd__,posId__xpd__,skidId,pdtId__xpd__,qty,unit,ctns,origin,pkg,note',
        tblName: tblNameInventoryCheckItems,
        page: 0,
        rcdsPerPage: 10,
        filter: filterInventoryCheckItems,
        // showIndex,
        // expands:[
        //     {

        //     }
        // ],
        opts:{
            hideIndex: true,
            hideID: true,
        },
        btns:{
            edit: ({rcdId, setRcdActive})=><button type="button"
                className="btn btn-sm btn-primary"
                onClick={evt=>{
                    // // evt.stopPropagation();
                    // setTblName(tblNameInventoryCheckItems);
                    // // [] for RcdEditDialog
                    // setRcdId(rcdId);
                    // // [] for list
                    // setRcdActive&&setRcdActive();
                    // openDialog();
                }}
            >edit</button>,
            addChild: ({rcdId, setRcdActive, listType})=>(listType=="Tree")&&<button type="button"
                className="btn btn-sm btn-primary"
                onClick={evt=>{
                    // // evt.stopPropagation();
                    // setTblName(tblNameInventoryCheckItems);
                    // // [] for RcdEditDialog
                    // // getNewRcdId()
                    // setRcdId(false);
                    // console.log('rcd default:', {...getRcdDefault(), pid:rcdId});
                    // setRcdDefault({...getRcdDefault(), __pid:rcdId})

                    // // [] for list
                    // setRcdActive&&setRcdActive();
                    // openDialog();
                }}
            >add child</button>,
            delete: ({rcdId, setRcdActive})=><button type="button"
                className="btn btn-sm btn-warning"
                onClick={evt=>{
                    // // evt.stopPropagation();
                    // setTblName(tblNameInventoryCheckItems);
                    // // [] for RcdEditDialog
                    // setRcdId(rcdId);
                    // setTimeout(_=>{
                    //     if(window.confirm('sure to delete?')){

                    //     }
                    //     setRcdActive&&setRcdActive();
                    // }, 10)
                    // setRcdActive&&setRcdActive();

                }}
            >delete</button>
    }}));

    const fldNamesInventoryCheckItems = 'date,for,forId,dir,warehouseId,posId,skidId,pdtId,qty,unit,ctns,origin,pkg,note';
    return <DefaultResponse>
        <EditNewDialog></EditNewDialog>
        <DlgInvCheckInfoDlg>
            <ListInventoryCheckItemsList></ListInventoryCheckItemsList>
            {/* <table className="table">
                <thead>
                    <tr>
                        {fldNamesInventoryCheckItems.split(',').map(fldName=><th key={fldName}>{fldName}</th>)}
                    </tr>
                </thead>
                <tbody>
                        {((rcdsInventoryCheckItems||{}).rcds||[]).map(rcd=><tr key={rcd.__id}>
                            {fldNamesInventoryCheckItems.split(',').map(fldName=><td key={fldName}>{rcd[fldName]}</td>)}
                        </tr>)}
                </tbody>
            </table> */}

        </DlgInvCheckInfoDlg>
        <div className="input-group">
            <span className="input-group-text">check id</span>
            <select
                className="form-control form-control-sm"
                defaultValue={chkId}
                onChange={evt=>{
                    setTimeout(_=>setChkId(evt.target.value), 10);
                }}
                role="chk"
            >
                <option
                    key={0}
                    value={0}
                ></option>
                {((tblInventoryChecks||{}).rcds||[]).map((rcd, idx)=><option
                    key={rcd.__id}
                    value={rcd.__id}
                >
                    {rcd.date} / {rcd.sn}
                </option>)}
            </select>
            <button className="btn btn-sm btn-outline-secondary" type="button"
                onClick={evt=>{
                    // [] for RcdEditDialog
                    // setTblName('inventoryChecks');
                    setEditNewRcdId(false);
                    openEditNewDlg();
                }}
            >+</button>
            <button className="btn btn-sm btn-outline-secondary" type="button"
                onClick={evt=>{
                    // [] for RcdEditDialog
                    // setTblName('inventoryChecks');
                    setEditNewRcdId(chkId);
                    openEditNewDlg();
                }}
            >E</button>
            <button className="btn btn-sm btn-outline-secondary" type="button"
                onClick={evt=>{
                    openDlgInvCheckInfoDlg();
                }}
            >i</button>
            <button className="btn btn-sm btn-outline-secondary" type="button"
                onClick={evt=>{
                    setChkId(0);
                }}
            >X</button>
        </div>
    </DefaultResponse>;
}

export function PosSelector({addressMap, setPosFilterLbl, posFilter}){
    return <div className="row">
        <div className="col">
            <div className="input-group">
                {addressMap.map((lbls, idx)=><Fragment
                    key={Math.random()}
                >
                        {/* <span className="input-group-text">-</span> */}
                        <select
                            role={ `lbl-${idx+1}`}
                            className="form-control form-control-sm"
                            defaultValue={posFilter[idx]}
                            onChange={evt=>{
                                // setRow(evt.target.value);
                                setPosFilterLbl(idx, evt.target.value);
                            }}
                        >
                            <option></option>
                            {Object.keys(lbls).map((lbl, idx)=><option
                                key={lbl}
                            >
                                {lbl}
                            </option>)}
                        </select>
                        <button className="btn btn-sm btn-outline-secondary" type="button"
                            onClick={evt=>{
                                setPosFilterLbl(idx, '');
                            }}
                        >X</button>
                    </Fragment>
                )}
            </div>
        </div>
    </div>
};

export function SkidInfo({posId, skidId}){
    return <div>skid info {posId}</div>;
}

export function SkidPdtsChk({skidId, chkId}){
    const {regUse, isLoading, isReady, hasError, DefaultError, DefaultLoading, DefaultResponse} = regUses();
    const {data:rcdsCheck} = regUse(useRcds('inventoryCheckItems', 0, 9999, {
        for: 'chkInv',
        forId: 1
    }))
    return <div>
        <DefaultResponse>
            <h1>ready!</h1>
        </DefaultResponse>
        skidId: {skidId}<br />
        chkId: {chkId}
    </div>;
}

export function InvCheckSummary({chkId}){
    const {regUse, DefaultResponse} = regUses();
    const {data:rcdInvCheck} = regUse(useRcd('inventoryChecks',chkId))
    return <DefaultResponse>
        <h1>{chkId} - {(rcdInvCheck||{}).sn}</h1>
    </DefaultResponse>;
}

export function WarehouseSummary({addressId}){
    const {regUse, DefaultResponse} = regUses();
    // const flter =  {
    //     warehouseId: addressId==2?`(^${addressId}$|^\w*$)`:`^${addressId}$`
    // };
    // const {data:rcdsInvChgItms} = regUse(useRcds('inventoryChangeItems',0,9999,flter));
    // // const {data:tblPdts} = regUse(useTbl('pdts'));

    const filterInventoryChangeItems = {
        // __filtersRelation: 'all',
        // __filterFlds:{
        //     skidId: `^(${(rcdPos||{}).skidId})$`,
        //     forId: `^${chkId}$`
        // }
        warehouseId: addressId==2?`(^${addressId}$|^\w*$)`:`^${addressId}$`
    };
    const tblNameInventoryChangeItems = 'inventoryChangeItems';
    // const {data:rcdsInventoryCheckItems} = regUse(useRcds(tblNameInventoryChangeItems,0,9999,filterInventoryChangeItems));
    const {
        Component: ListInventoryCheckItemsList,
        loading:TblListLoading,
        error:TblListError,
        invalidate:invalidateList,
        setActiveRcdId,
        setListType
    } = regUse(useRcdList({
        listType: 'list',

        hideListTypeSelector: true,

        listFlds: 'date,for,forId,dir,warehouseId,posId,skidId,pdtId,qty,unit,ctns,origin,pkg,note',
        tblName: tblNameInventoryChangeItems,
        page: 0,
        rcdsPerPage: 10,
        filter: filterInventoryChangeItems,
        // showIndex,
        opts:{
            hideIndex: true,
            hideID: true,
        },
        btns:{
            edit: ({rcdId, setRcdActive})=><button type="button"
                className="btn btn-sm btn-primary"
                onClick={evt=>{
                    // // evt.stopPropagation();
                    // setTblName(tblNameInventoryChangeItems);
                    // // [] for RcdEditDialog
                    // setRcdId(rcdId);
                    // // [] for list
                    // setRcdActive&&setRcdActive();
                    // openDialog();
                }}
            >edit</button>,
            addChild: ({rcdId, setRcdActive, listType})=>(listType=="Tree")&&<button type="button"
                className="btn btn-sm btn-primary"
                onClick={evt=>{
                    // // evt.stopPropagation();
                    // setTblName(tblNameInventoryChangeItems);
                    // // [] for RcdEditDialog
                    // // getNewRcdId()
                    // setRcdId(false);
                    // console.log('rcd default:', {...getRcdDefault(), pid:rcdId});
                    // setRcdDefault({...getRcdDefault(), __pid:rcdId})

                    // // [] for list
                    // setRcdActive&&setRcdActive();
                    // openDialog();
                }}
            >add child</button>,
            delete: ({rcdId, setRcdActive})=><button type="button"
                className="btn btn-sm btn-warning"
                onClick={evt=>{
                    // // evt.stopPropagation();
                    // setTblName(tblNameInventoryChangeItems);
                    // // [] for RcdEditDialog
                    // setRcdId(rcdId);
                    // setTimeout(_=>{
                    //     if(window.confirm('sure to delete?')){

                    //     }
                    //     setRcdActive&&setRcdActive();
                    // }, 10)
                    // setRcdActive&&setRcdActive();

                }}
            >delete</button>
    }}));

    const {getPdtById} = regUse(usePdts())
    // console.log('rcdsInvChgItms:', flter, rcdsInvChgItms);
    // posQtys,skidId,
    const fldNames = 'date,for,forId,batch,dir,warehouseId,posId,pdt,qty,unit,ctns,origin,pkg,note';
    return <div>
        <h1>{addressId}</h1>
        <DefaultResponse>
            <ListInventoryCheckItemsList></ListInventoryCheckItemsList>
            {/* <table className="table">
                <tr>{fldNames.split(',').map(fldName=><th
                    key={fldName}
                >{fldName}</th>)}</tr>
            {((rcdsInvChgItms||{}).rcds||[]).map(rcdInvChgItms=>{
                // const pdt = (tblPdts.rcdsById||{})[rcdInvChgItms.pdtId]||{};
                const pdt = getPdtById(rcdInvChgItms.pdtId) || {};
                rcdInvChgItms['pdt'] = pdt.getCaption(); //`[${pdt.sn}] ${pdt.name}`;
                return <tr
                    key={rcdInvChgItms.__id}
                >
                    {fldNames.split(',').map(fldName=>{

                        return <td
                            key={`${rcdInvChgItms.__id}-${fldName}`}
                        >{rcdInvChgItms[fldName] || '-'}</td>;
                    })}
                </tr>;
            })}
            </table> */}
        </DefaultResponse>
    </div>;
}

export function PosPdtsChk_PdtsList({rcdPos, chkId, chkRefData}){
    const refData = useRef({
        invalidateInvChkItmsList: false
    });
    const tblName = 'inventoryCheckItems';
    const [refreshId, setRefreshId] = useState(0);
    const refresh = _=> setRefreshId(refreshId+1);

    const {regUse, DefaultResponse} = regUses();
    const flter = {
        __filtersRelation: 'all',
        __filterFlds:{
            skidId: `^(${(rcdPos||{}).skidId})$`,
            forId: `^${chkId}$`
        }
    };
    const {data:rcdsInvChkItms} = regUse(useExpandedRcds('inventoryCheckItems',0,9999,flter,{reset:refreshId}));
    const invChkItmsEditDlg = regUse(useRcdEditDialog({
        tblName,
        rcdId:null,
        onSaved: r=>{
            refData.current.invalidateInvChkItmsList && refData.current.invalidateInvChkItmsList();
            console.log('saved!!!')
            // invalidateList();
            // forceUpdate();
            // const idsChanged = ((r.data.data||[]).find(rcd=>rcd.tblName==tblName)||{}).__idsChanged;
            // if(idsChanged){
            //     // const tgtId = idsChanged[0];
            //     // setChkId(tgtId);
            //     refresh();
            // }
            // refresh();
        }
    }));
    const {
        // formId: editRcdFormId,
        isDialogOpen,
        setIsDialogOpen,
        openDialog:openDlgAddEditInvChkItem,
        closeDialog,
        handleConfirm,

        setTblName,
        setRcdId:setEditNewInvChkItmRcdId,
        setRcdDefault: setInvChkItmDefault,
        setRcdDefault,
        getRcdDefault,

        invalidate:invalidateRcdInvChkItem,

        Dialog: DlgAddEditInvChkItem,
        
    } = invChkItmsEditDlg;


    function MoveSkidToPos({skidId, addressId}){
        return <div>developing</div>;
    }
    function _MoveSkidToPos({skidId, addressId}){
        const {regUse, DefaultResponse} = regUses();
        const {
            Dialog: DialogMSTP,
            openDialog: openDialogMSTP,
            closeDialog: closeDialogMSTP,

        } = useDialog({
            dlgTitle: 'move skid to position'
        });

        const {data:maps} = regUse(useMaps({addressId, default:2}));
        const addressMap = (maps||{})[addressId] || [];

        return <DefaultResponse>
            <DialogMSTP>
                <PosSelector
                    addressMap={addressMap}
                    setPosFilterLbl={_=>{}}
                    posFilter={[]}
                ></PosSelector>

            </DialogMSTP>
            <button type="button"
                className="btn btn-primary"
                onClick={evt=>{
                    openDialogMSTP();
                }}
            >move to</button>            
        </DefaultResponse>;

    }

    const invChkItmsFlds = 'for,forId,skidId,pdtId,pdtId__xpd__,qty,unit,ctns,origin';
    const {Component:ItemList, invalidate:invalidateInvChkItmsList} = regUse(useRcdList({
        tblName, rcdsPerPage:99999,
        hideID:true, hideSearch:true, hidePagination:true,
        hideListFldsSelector:true, hideListTypeSelector: true,
        listFlds: invChkItmsFlds,
        filter: flter,
        btns:[
            'stdEdit', 'stdDelete',
            ({rcdId, rcd})=>{
                return <MoveSkidToPos
                    skidId={rcd.skidId}
                    addressId={2}
                ></MoveSkidToPos>
            }
        ],
        editDlg: invChkItmsEditDlg
    }));
    refData.current.invalidateInvChkItmsList = invalidateInvChkItmsList;

    return <DefaultResponse>
        {/* <div>
            {JSON.stringify(flter)}
        </div> */}
        {/* ref raw data */}
        <div className="container">
            {/* ref data */}
            {false&&<div className="row">
                <h1>ref data</h1>

                {(chkItms=>{
                    const flds = "for,forId,posSn,skidId,pdtId,pdtSn,pdtBrandAbbr,qty".split(',');
                    return <table className="table table-striped">
                        <thead>
                            <tr>
                                {flds.map(fld=><td
                                    key={Math.random()}
                                >
                                    {fld}
                                </td>)}
                                <th>action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(chkItms||[]).map(chkItm=>{
                                chkItm.qtyDZ = chkItms.qty / 12;
                                return <tr
                                    key={Math.random()}
                                >
                                    {flds.map(fld=><td
                                        key={Math.random()}
                                    >
                                        <div className="d-flex row">
                                            <div
                                                className="ww-rcdlist-label fw-bold"
                                            >{fld}:</div>
                                            <div>
                                                {String(chkItm[fld])}
                                            </div>
                                        </div>
                                    </td>)}
                                    <td><button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={evt=>{
                                            setEditNewInvChkItmRcdId(0);
                                            setInvChkItmDefault({
                                                date: (new Date()).toISOString().split('T')[0],
                                                dir: 1,
                                                for: "chkInv",
                                                forId: chkId,
                                                skidId: (rcdPos||{}).skidId,
                                                posId: (rcdPos||{}).__id,
                                                warehouseId:  (rcdPos||{}).addressId,

                                                pdtId: chkItm.pdtId,
                                                qty:  chkItm.qty,
                                                unit: 'PC'

                                            });
                                            openDlgAddEditInvChkItem();
                                        }}
                                    >add to check</button></td>
                                </tr>;
                            })}
                        </tbody>
                    </table>
                    
                })(chkRefData)}

            </div>}
            {/* add new button */}
            <div className="row">
                <h1>check data</h1>
                <div className="col">
                    <button className="form-control"
                        onClick={evt=>{
                            setEditNewInvChkItmRcdId(0);
                            setInvChkItmDefault({
                                date: (new Date()).toISOString().split('T')[0],
                                dir: 1,
                                for: "chkInv",
                                forId: chkId,
                                skidId: (rcdPos||{}).skidId,
                                posId: (rcdPos||{}).__id,
                                warehouseId:  (rcdPos||{}).addressId
                            });
                            openDlgAddEditInvChkItem();
                        }}
                    >+</button>
                </div>
            </div>
        </div>

        {/* list */}
        <ItemList></ItemList>
        {/* {window.innerWidth>768?<table className="table">
            <thead>
                <tr>
                    <td>action</td>
                    {invChkItmsFlds.split(',').map(fldName=><th key={fldName}>{fldName}</th>)}
                </tr>
            </thead>
            <tbody>
                {((rcdsInvChkItms||{}).rcds||[]).map((rcdInvChkItms, idx0)=><tr
                    key={`&{rcdInvChkItms.__id}-${idx0}`}
                >
                        <td><button type="button"
                            className="btn btn-primary"
                            onClick={evt=>{
                                setEditNewInvChkItmRcdId(rcdInvChkItms.__id);
                                openDlgAddEditInvChkItem();
                            }}
                        >edit</button></td>
                        {invChkItmsFlds.split(',').map(fldName=><td key={fldName}>{rcdInvChkItms[fldName]}</td>)}
                    </tr>
                )}
            </tbody>
            </table>
            :<div>
                {((rcdsInvChkItms||{}).rcds||[]).map((rcdInvChkItms,idx)=><div>
                    <div className="mt-1 card p-3">
                        <div># {idx+1}</div>
                        <div>
                            <button type="button"
                                className="btn btn-primary"
                                onClick={evt=>{
                                    setEditNewInvChkItmRcdId(rcdInvChkItms.__id);
                                    openDlgAddEditInvChkItem();
                                }}
                            >edit</button>
                            <button type="button"
                                className="btn btn-primary"
                                onClick={evt=>{
                                    if(confirm('delete?')){
                                        // delTblRcds(tblName, rcdId).then(r=>{
                                        //     invalidateList();
                                        // })
                                    }
                                }}
                            >delete</button>
                        </div>
                        {invChkItmsFlds.split(',').map(fldName=><div key={fldName} style={{display: "flex"}}><strong className="me-2" style={{flex: "1"}}>{fldName}:</strong><span style={{flex: "3"}}>{rcdInvChkItms[fldName]}</span></div>)}
                    </div>
                </div>
                )}
            </div>} */}

        {/* add new dialog */}
        <DlgAddEditInvChkItem

        ></DlgAddEditInvChkItem>
    </DefaultResponse>;
}

export function PosPdtsChk({chkId, posId, chkRefData}){
    const {regUse, DefaultResponse} = regUses();
    const {data:rcdPos} = regUse(useRcd('poses', posId));
    const {data:rcdChk} = regUse(useRcd('inventoryChecks', chkId));

    return <DefaultResponse>
        <h3>chkId: {chkId} - {(rcdChk||{}).date}/{(rcdChk||{}).sn}</h3>
        <h3>position: {posId} - {(rcdPos||{}).sn}</h3>
        <h3>addressId: {(rcdPos||{}).addressId}</h3>
        <h3>products at this position: </h3>
        <PosPdtsChk_PdtsList
            rcdPos={rcdPos}
            chkId={chkId}
            chkRefData={chkRefData}
        ></PosPdtsChk_PdtsList>
    </DefaultResponse>;
}


export default function InventoryChk2({}){
    const [refreshId, setRefreshId] = useState(0);
    const refresh = _=> setRefreshId(refreshId+1);

    const {regUse, DefaultResponse} = regUses();
    
    const refData = useRef({
        addressId: undefined,
        row: undefined,
        col: undefined,
        lvl: undefined,

        chkId: 0,
        rcdPos: false,

        skidChkStatusIdx: 0,
    });
    const refAddr = useRef();
    const [addressId, setAddressId] = useState(0);
    const {WarehouseSelector} = useWarehouseSelector({
        warehouseId:addressId,
        setWarehouseId:setAddressId
    });
    
    const [row, setRow] = useState(0);
    const [col, setCol] = useState(0);
    const [lvl, setLvl] = useState(0);
    const [posFilter, setPosFilter] = useState([]);

    const {data: rawData} = regUse(useChkRawData());

    const {data:maps} = regUse(useMaps({addressId, default:2}));
    const addressMap = (maps||{})[addressId] || [];

    const _getFilter = _=>{
        // const posData = refData.current;
        // const row = refRow.current?refRow.current.value:undefined;
        // const col = refCol.current?refCol.current.value:undefined;
        // const lvl = refLvl.current?refLvl.current.value:undefined;

        // if(!posData)return;
        const filter = {};

        filter.sn = `${row?`[^\\d-]*${row}`:'.*'}-${col?col:'.*'}-${lvl?`${lvl}[^\\d-]*`:'.*'}`;
        filter.addressId = addressId;

        return filter;
    }

    const getFilter = _=>{
        // const posData = refData.current;
        // const row = refRow.current?refRow.current.value:undefined;
        // const col = refCol.current?refCol.current.value:undefined;
        // const lvl = refLvl.current?refLvl.current.value:undefined;

        // if(!posData)return;
        function removeTrailingNulls(arr) {
            let end = arr.length;
            while (end > 0 && !arr[end - 1]) {
                end--;
            }
            return arr.slice(0, end);
        }
        const filterFlds = {};
        filterFlds.addressId = addressId;

        const pf = removeTrailingNulls(posFilter);
        // filterFlds.sn = '^'+Object.keys(pf).map(idx=>{
        //     const lbl = (pf[idx]||'').trim();
        //     return lbl?`${lbl}`:'[^-*]*';
        // }).join('-');
        const sn = [];
        for (let idx = 0; idx < pf.length; idx++) {
            const lbl = (pf[idx]||'').trim();
            sn.push(lbl?`${lbl}`:'[^-*]*');
        }
        filterFlds.sn = '^' + sn.join('-');
        if(pf.length!=0 && pf.length<Object.keys(addressMap).length)filterFlds.sn += '-';

        const filter = {
            __filtersRelation:'all',
            __filterFlds: filterFlds
        }

        console.log('filter:', filter)
        return filter;
    }

    const [posId, setPosId] = useState(0);
    const [chkId, setChkId] = useState(0);
    refData.current.chkId = chkId;

    // const {data:tblInventoryChecks } = regUse(useTbl('inventoryChecks'));

    const {data:rcdInventoryChecks} = regUse(useRcd('inventoryChecks', chkId, {}, {
        refresh: refData.current.skidChkStatusIdx
    }));
    const {data:rcdPos} = regUse(useRcd('poses', posId, {}, {}));
    refData.current.rcdPos = rcdPos;
   
    const skidChkStatus = {};
    ((rcdInventoryChecks||{}).chkstatus || '').split(',').forEach(strChkStatusItem=>{
        const arrStatusItem = strChkStatusItem.split('|');
        skidChkStatus[arrStatusItem[0]] = arrStatusItem[1];
        // const statusItem = {
        //     skidId: arrStatusItem[0],
        //     status: arrStatusItem[1] // 0 - not check, 1 - checked 
        // }
    });
    const setCheckStatus =(chkId, skidId, status)=>{
        // console.log(chkId, skidId, status);
        if(skidId){
            const statusToUpdate = {};
            statusToUpdate[skidId] = status;
            updateSkidChkStatus(chkId, statusToUpdate).then(r=>{
                if(!status){
                    delete(skidChkStatus[skidId]);
                }else{
                    skidChkStatus[skidId] = status;
                }

                closeDlgPosInfoDlg();

                // refresh
                refData.current.skidChkStatusIdx += 1;
                refresh();
            });
        }
    }

    const updateSkidChkStatus_update_rcd = async (chkId, skidChkStatus)=>{
        const chkstatus = Object.keys(skidChkStatus).filter(a=>a).map(skidId=>[skidId,skidChkStatus[skidId]].join('|')).join(',');
        return addTblRcds('inventoryChecks', [{__id: chkId, chkstatus}]).then(r=>{
            // console.log(r);
            refData.current.skidChkStatusIdx += 1;
            closeDlgPosInfoDlg();
            refresh();
        });
    }

    const updateSkidChkStatus = async (chkId, chkstatus)=>{
        return setChkSkidStatus(chkId, chkstatus);
    }

    const {Dialog: DlgPosInfo, openDialog:openDlgPosInfoDlg, closeDialog:closeDlgPosInfoDlg, setBtns, setDlgTitle} = useDialog({
        dlgTitle: 'check position',
        btns: [
            ({})=><button 
                type="button"
                className="btn btn-primary"
                onClick={evt=>{
                    const rcdPos = refData.current.rcdPos || {};
                    const skidId = rcdPos.skidId;
                    if(skidId){
                        const statusToUpdate = {};
                        statusToUpdate[skidId] = 1
                        updateSkidChkStatus(refData.current.chkId, statusToUpdate).then(r=>{
                            skidChkStatus[skidId] = 1;
                            closeDlgPosInfoDlg();

                            // refresh
                            refData.current.skidChkStatusIdx += 1;
                            refresh();
                        });
                    }
                }}
            >mark as checked</button>,
            ({})=><button 
                type="button"
                className="btn btn-warning"
                onClick={evt=>{
                    const rcdPos = refData.current.rcdPos || {};
                    const skidId = rcdPos.skidId;
                    if(skidId){
                        const statusToUpdate = {};
                        statusToUpdate[skidId] = 0;
                        updateSkidChkStatus(refData.current.chkId, statusToUpdate).then(r=>{
                            // skidChkStatus[skidId] = 0;
                            delete(skidChkStatus[skidId]);

                            closeDlgPosInfoDlg();

                            // refresh
                            refData.current.skidChkStatusIdx += 1;
                            refresh();
                        });
                    }

                }}
            >mark as unchecked</button>,
            'cancel',
        ]
    });

    const {Dialog: DlgWarehouseInfo, openDialog:openDlgWarehouseInfoDlg} = useDialog({
        dlgTitle: 'warehouse summary'
    });

    const {
        invalidate:invalidatePosList,
        setActiveRcdId,
        Component: PosList,
        setListType
    } = regUse(useRcdList({
        tblName: 'poses', 
        // page, 
        rcdsPerPage: 9999, 
        filter: getFilter(),
        reset: JSON.stringify(getFilter()),
        // showIndex, 
        // btns, listFlds:listFldsIn, 
        listType:'cards',
        dataFlds: '__id,skidId',
        hidePagination: true,
        hideSearch: true,
        hideListTypeSelector: true,
        // CompList: ()=><h5>list item</h5>,

        onItemClick: ({tblName, rcdId, evt, rcd})=>{
            setPosId(rcdId);
            openDlgPosInfoDlg({
                fnOnOpenOnce: _=>{
                    // skidChkStatus[rcd.skidId]?setBtns([_=><button type="button">test</button>]):setBtns([]);
                    setBtns([
                        (!skidChkStatus[rcd.skidId])?({})=><button 
                            type="button"
                            className="btn btn-primary"
                            onClick={evt=>setCheckStatus(chkId, (refData.current.rcdPos||{}).skidId, 1)}
                        >mark as checked</button>
                        :({})=><button 
                            type="button"
                            className="btn btn-warning"
                            onClick={evt=>setCheckStatus(chkId, (refData.current.rcdPos||{}).skidId, 0)}
                        >mark as unchecked</button>,
                        'cancel',
                    ])
                    setDlgTitle(`check inventory at position ${(rcd||{}).sn}`);
                    // setDlgTitle(`${rcdId} --> ${JSON.stringify(rcd||{})}`);
                }
            });
        },
        // btns: {
        //     edit: ({rcdId, setRcdActive})=><button type="button"
        //         className="btn btn-sm btn-sm btn-primary"
        //         onClick={evt=>{
        //             // evt.stopPropagation();
        //             // setTblName('poses');
        //             // [] for RcdEditDialog
        //             setPosId(rcdId);
        //             // [] for list
        //             setRcdActive&&setRcdActive();
        //             openDlgPosInfoDlg();
        //         }}
        //     >edit</button>,
        // },

        opts:{
            cardShowFlds: 'sn,skidId,addressId__xpd__'
        },

        highLightFn: (skidChkStatus=>rcd=>(skidChkStatus||{})[rcd.skidId])(skidChkStatus)

        // CompList
    }));

    function setPosFilterLbl(idx, val){
        const newFilter = [...posFilter];
        newFilter[idx] = val;
        setPosFilter(newFilter);
    }

    const {
        // formId: editRcdFormId,
        isDialogOpen,
        setIsDialogOpen,
        openDialog:openEditNewDlg,
        closeDialog,
        handleConfirm,

        setTblName:setEditNewRcdTblName,
        setRcdId:setEditNewRcdId,
        setRcdDefault:setEditNewRcdDefault,
        getRcdDefault,

        invalidate:invalidateRcdInventoryChecks,

        Dialog: EditNewDialog,
        
    } = regUse(useRcdEditDialog({
        tblName:'inventoryChecks',
        rcdId:null,
        onSaved: _=>{
            invalidatePosList();
            refresh();
        }
    }));

    const rawDataByPos = ((rawData || {}).rcdsByPos || {});

    return <div>
        <div className="container">
            <h3 className="p-3">InventoryChk2 </h3>
            <div className="row">
                <div className="col">
                    <div className="row">
                        <div className="col">
                            <WarehouseSelector></WarehouseSelector>
                        </div>
                        <div className="col">
                            <ChkIdSelector
                                chkId={chkId}
                                setChkId={setChkId}
                                openEditNewDlg={openEditNewDlg}
                                setEditNewRcdId={setEditNewRcdId}
                            ></ChkIdSelector>
                        </div>                            
                    </div>
                </div>
            </div>

            <WarehouseChkInfo
                warehouseId={addressId}
                chkId={chkId}
            ></WarehouseChkInfo>

            <DefaultResponse>
                {/* [] position selector */}
                <PosSelector
                    addressMap={addressMap}
                    setPosFilterLbl={setPosFilterLbl}
                    posFilter={posFilter}
                ></PosSelector>
                {/* [] add new position button */}
                <div
                    className={["mt-2", css.poses].join(' ')}
                >
                    {/* <div className="row">
                        <div className="col">filter</div>
                        <div className="col">{JSON.stringify(getFilter())}</div>
                    </div> */}
                    <div className="row">
                        <div className="col">
                            <button className="btn btn-primary"
                                onClick={evt=>{
                                    setEditNewRcdTblName('poses');
                                    setEditNewRcdId(0);
                                    setEditNewRcdDefault({
                                        addressId,
                                        skidId: generateNewSkidId()
                                    });
                                    openEditNewDlg();
                                }}
                            >add new position to warehouse</button>
                        </div>
                    </div>

                    {/* [] position cards */}
                    <PosList
                        skidChkStatus = {skidChkStatus}
                    ></PosList>
                </div>
            </DefaultResponse>

        </div>
        <DlgPosInfo>
            {rcdPos&&<PosPdtsChk
                chkRefData={rawDataByPos[rcdPos.sn]}
                posId={posId}
                chkId={chkId}
            ></PosPdtsChk>}
        </DlgPosInfo>
        <DlgWarehouseInfo>
            <WarehouseSummary
                addressId={addressId}
            ></WarehouseSummary>
        </DlgWarehouseInfo>

        <EditNewDialog></EditNewDialog>
    </div>
}

